<div class="vehicle-header" data-testid="vehicle-select-container">
  <div class="car-icon-row">
    <img class="car-image" appVehicleImageFallback
      [src]="VEHICLE_IMAGE_URL.replace('$skin', settingsService.getMap().Skin).replace('$icon_name', selectedCar?.Icon || '')" alt="vehicle" />
  </div>

  @if (accountService.getIsAuthorized() && userVehicles().length > 0) {
  <div class="vehicle-dropdown">
    <mat-form-field class="modal-select-field vehicle-dropdown-field">
      <mat-select disableRipple panelClass="modal-select-panel" data-testid="vehicle-select-vehicle-dropdown" [(value)]="selectedDropdownValue"
        (valueChange)="dropdownChanged($event)">
        @for (v of userVehicles(); track v.userVehicleID) {
        <mat-option [attr.data-testid]="'vehicle-select-vehicle-option-' + v.userVehicleID" [value]="(v.userVehicleID + '')">{{ getVehicleLabel(v) }}</mat-option>
        }
        @if (vehicleLimitReached()) {
        <mat-option disabled data-testid="vehicle-select-limit-option">{{
          languageService.languageJSON?.ManageCars_VehicleLimitReached }}</mat-option>
        } @else {
        <mat-option [value]="ADD_NEW_KEY" data-testid="vehicle-select-add-new-option"><img class="add-icon" src="assets/icons/default/ui/add_icon.svg" alt="add" /> {{
          languageService.languageJSON?.ManageCars_AddNewCar }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }
</div>
<div class="vehicle-details scrollable">
  <app-modal-option-panel>
    <div class="vehicle-select-list">
      <div class="select-row">
        <label id="vehicle-select-brand-label" for="vehicle-select-brand">{{ languageService.languageJSON?.CarSelectorDialog_Brand }}</label>
        <mat-form-field class="modal-select-field vehicle-select-field brand-select-field">
          <mat-select disableRipple panelClass="modal-select-panel brand-select-panel" data-testid="vehicle-select-brand-select"
            id="vehicle-select-brand" aria-labelledby="vehicle-select-brand-label" [(value)]="carType"
            (selectionChange)="carTypeChanged.emit($event.value)">
            <mat-option>
              <ngx-mat-select-search [formControl]="brandFilterCtrl"
                [placeholderLabel]="languageService.languageJSON?.Global_Search" [noEntriesFoundLabel]="''">
                <div class="mat-select-search-custom-header-content"></div>
                <span ngxMatSelectSearchClear class="mat-select-search-clear-icon">&times;</span>
              </ngx-mat-select-search>
            </mat-option>
            @for (type of filteredCarTypes(); track type.name; let i = $index) {
            <mat-option [attr.data-testid]="'vehicle-select-brand-option-' + i" [value]="type.name">{{ type.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (CarTypes[carTypeIndex] && CarTypes[carTypeIndex].subtypes.length > 0) {
      <div class="select-row">
        <label id="vehicle-select-model-label" for="vehicle-select-model">{{ languageService.languageJSON?.CarSelectorDialog_Model }}</label>
        <mat-form-field class="modal-select-field vehicle-select-field">
          <mat-select disableRipple panelClass="modal-select-panel" data-testid="vehicle-select-model-select"
            id="vehicle-select-model" aria-labelledby="vehicle-select-model-label" [(value)]="carSubType"
            (selectionChange)="carSubTypeChanged.emit($event.value)">
            @for (subtype of CarTypes[carTypeIndex].subtypes; track subtype; let i = $index) {
            <mat-option [attr.data-testid]="'vehicle-select-subtype-option-' + i" [value]="subtype">{{ subtype }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }

      <div class="select-row">
        <label id="vehicle-select-type-label" for="vehicle-select-type">
          @if (CarTypes[carTypeIndex] && CarTypes[carTypeIndex].subtypes.length === 0) {
          {{ languageService.languageJSON?.CarSelectorDialog_Model }}
          }
          @if (CarTypes[carTypeIndex] && CarTypes[carTypeIndex].subtypes.length > 0) {
          {{ languageService.languageJSON?.CarSelectorDialog_Type }}
          }
        </label>
        @if (multipleCarType) {
        <mat-form-field class="modal-select-field vehicle-select-field">
          <mat-select disableRipple panelClass="modal-select-panel" data-testid="vehicle-select-type-select"
            id="vehicle-select-type" aria-labelledby="vehicle-select-type-label" [(value)]="$any(selectedCar).Name">
            @for (ecar of ECars | carFilter : carType : carSubType; track ecar.Id) {
            <mat-option [attr.data-testid]="'vehicle-select-type-option-' + ecar.Id" [value]="ecar.Name" (click)="carChanged.emit(ecar)" (keydown.enter)="carChanged.emit(ecar)">
              {{ ecar.Name | carNameFilter : carType : carSubType }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        @if (!multipleCarType && selectedCar) {
        <div class="readonly-pill">{{ selectedCar.Name }}</div>
        }
      </div>
    </div>

    <div class="vehicle-tiles">
      <div class="vehicle-tile">
        <img [src]="'assets/icons/light/ui/vehicle_settings_icon_capacity.svg'" alt="design capacity" />
        <span>{{ selectedCar?.DesignCapacity }} kWh</span>
      </div>
      <div class="vehicle-tile">
        <img [src]="'assets/icons/light/ui/vehicle_settings_icon_range.svg'" alt="range" />
        <span [hidden]="settingsService.getUnit().Distance !== 'metric'">
          {{ selectedCar?.FactoryRange }} km ({{ selectedCar?.FactoryRangeSource }})
        </span>
        <span [hidden]="settingsService.getUnit().Distance !== 'imperial'">
          {{ (selectedCar?.FactoryRange ?? 0) * 0.621371192 | valueInteger }} mi ({{ selectedCar?.FactoryRangeSource
          }})
        </span>
      </div>
      <div class="vehicle-tile">
        <img [src]="'assets/icons/light/ui/vehicle_settings_icon_topspeed.svg'" alt="top speed" />
        <span [hidden]="settingsService.getUnit().Speed !== 'metric'">{{ selectedCar?.TopSpeed }} km/h</span>
        <span [hidden]="settingsService.getUnit().Speed !== 'imperial'">
          {{ (selectedCar?.TopSpeed ?? 0) * 0.621371192 | valueInteger }} mph
        </span>
      </div>
      <div class="vehicle-tile">
        <img [src]="'assets/icons/light/ui/vehicle_settings_icon_totalpower.svg?v=2'" alt="total power" />
        <span>{{ selectedCar?.TotalPower }} kW</span>
      </div>
    </div>
  </app-modal-option-panel>

  @if (accountService.getIsAuthorized()) {
  <app-modal-option-panel>
    <label panel-title class="card-label" for="vehicle-select-custom-name">{{ languageService.languageJSON?.CarSelectorDialog_CustomName }}</label>
    <div class="custom-name-input" [formGroup]="customCarNameForm">
      <input id="vehicle-select-custom-name" formControlName="customCarName" type="text" data-testid="vehicle-select-custom-name-input" [placeholder]="selectedCar?.Name" />
    </div>
  </app-modal-option-panel>
  }

  @if (editedUserCar) {
  <div class="delete-row">
    <button class="delete-btn" data-testid="vehicle-select-delete-btn" (click)="deleteCar()">
      {{ languageService.languageJSON?.ManageCars_RemoveVehicle }}
    </button>
  </div>
  }
</div>